import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { POADocumentType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface GenerateDocumentProps {
  importerId: string;
  type: POADocumentType;
}

export const useGenerateDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ importerId, type }: GenerateDocumentProps) => {
      const result = await apiClient.importer.generateDocument.mutation({ params: { id: importerId, type } });
      if (result.status !== 200) throw result.body;
      return result.body;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['importer', variables.importerId] });
      toast.success(`${variables.type} document generated!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error generating document!`);
    },
  });
};
